import RoboIcon from './RoboIcon'

export default RoboIcon
